import useSWRImmutable from 'swr/immutable';
import capsFetcher from '../../resources/shared/capsFetcher';

const fetcher = async ({ data }) => {
  const res = await capsFetcher({
    method: 'POST',
    url: '/plaid/link_token',
    data,
  });
  return res;
};

const usePlaidLinkToken = (data, options) => useSWRImmutable(
  data ? { data } : null, // Prevents premature fetching
  fetcher,
  { suspense: true, ...options },
);

export default usePlaidLinkToken;
